module.exports = "<div>This is the stations view.</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/admin/stations/stations.html
// module id = 166
// module chunks = 0